<template>
  <p v-if="!hasParams" class="empty">Нет данных пользователя</p>
  <p v-else-if="pending" class="empty">Загрузка…</p>
  <p v-else-if="error" class="error">Не удалось загрузить уведомления</p>
  <p v-else-if="!messages.length" class="empty">Нет уведомлений</p>
  <ul v-else class="list">
    <li v-for="msg in messages" :key="msg.id">
      <button
        type="button"
        class="message"
        :class="{
          'message--unread': isUnread(msg),
          'message--clickable': isClickable(msg),
        }"
        :aria-label="unreadAriaLabel(msg)"
        @click="$emit('select', msg)"
      >
        <span
          class="message-dot"
          :class="{ 'message-dot--on': isUnread(msg) }"
          :title="isUnread(msg) ? 'Непрочитано' : undefined"
          aria-hidden="true"
        />
        <span class="message-body">
          <span class="message-text">{{ msg.content }}</span>
          <span class="message-meta">{{ formatRelativeTime(msg.created_at) }}</span>
        </span>
      </button>
    </li>
  </ul>
</template>

<script setup>
import { formatRelativeTime, isMessageUnread } from '@/components/notifications/notificationLogic.mjs'
import { notificationIsNavigable } from '@/components/notifications/notificationWsLogic.mjs'

defineProps({
  messages: { type: Array, default: () => [] },
  pending: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
  hasParams: { type: Boolean, default: true },
})

defineEmits(['select'])

function isUnread(msg) {
  return isMessageUnread(msg)
}

function isClickable(msg) {
  return isMessageUnread(msg) || notificationIsNavigable(msg)
}

function unreadAriaLabel(msg) {
  if (!isMessageUnread(msg)) return undefined
  const text = String(msg?.content || '').trim()
  return text ? `${text}, непрочитано` : 'Непрочитанное уведомление'
}
</script>

<style scoped>
.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.message {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  background: transparent;
  text-align: left;
  cursor: default;
  color: inherit;
}

.message--clickable {
  cursor: pointer;
}

.message--clickable:hover {
  background: #f9fafb;
}

.message--unread {
  background: #fff7f7;
}

.message--clickable.message--unread:hover {
  background: #feeeee;
}

.message-dot {
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: transparent;
  flex-shrink: 0;
}

.message-dot--on {
  background: #dc2626;
}

.message-body {
  min-width: 0;
  flex: 1;
}

.message-text {
  display: block;
  font-size: 0.9rem;
  color: #111827;
  white-space: pre-wrap;
  word-break: break-word;
}

.message--unread .message-text {
  font-weight: 600;
}

.message-meta {
  display: block;
  margin-top: 6px;
  font-size: 0.75rem;
  color: #9ca3af;
}

.empty,
.error {
  margin: 0;
  padding: 36px 16px;
  text-align: center;
  font-size: 0.9rem;
  color: #9ca3af;
}

.error {
  color: #dc2626;
}
</style>
